import appConfig from 'config/appConfig';
import client from './index';

export const createParticipantUserEntryApi = (vendorId, browserInfo, userLandingUrl) => client().post('createParticipantUserEntry', {
  vendorId,
  browserData: JSON.stringify(browserInfo),
  userLandingUrl,
  versionNumber: appConfig.version,
  userSpId: localStorage.getItem('spfjkshdfjbnvcbj'),
});
export const getParticipantDemoStatusV2Api = (vendorId, browserInfo, userLandingUrl) => client().get('getParticipantDemoStatusV2', {
  params: {
    vendorId,
    userLandingUrl,
    versionNumber: appConfig.version,
    userSpId: localStorage.getItem('spfjkshdfjbnvcbj'),
  },
});
export const createParticipantV3Api = (participantData, landingUrlString, newUserId, PID, botDetectionResult, browserLang) => client().get('createParticipantV3', {
  params: {
    queryParams: participantData,
    userLandingUrl: landingUrlString,
    cookieUserid: newUserId,
    PID,
    b2r: botDetectionResult && botDetectionResult.bot ? 1 : 0,
    userLang: browserLang,
    userSpId: localStorage.getItem('spfjkshdfjbnvcbj'),
  },
});

export const participantsDemographicsApi = (participantData, landingUrlString, newUserId, browserLang) => client().get('participantsDemographics', {
  params: {
    queryParams: participantData,
    userLandingUrl: landingUrlString,
    cookieUserid: newUserId,
    appType: 'zampparticipantV2',
    userLang: browserLang,
    userSpId: localStorage.getItem('spfjkshdfjbnvcbj'),
  },
});
export const participantFailedInScreenersV2Api = (data) => client().post('participantFailedInScreenersV2', data);
export const checkScreenerForQuotaRouterV2Api = (params) => client().post('checkScreenerForQuotaRouterV2', params);
export const saveParticipantReplyV2Api = (data) => client().post('saveParticipantReplyV2', data);

export const clientRedirectUpdateApi = (data) => client().get('clientRedirectUpdate', {
  params: {
    studyId: data.studyId,
    pid: data.pid,
    redirectUrl: data.redirectUrl,
    userSpId: localStorage.getItem('spfjkshdfjbnvcbj'),
  },
});

export const getExposeClientParticipantDataApi = (data) => client().get('getExposeClientParticipantData', {
  params: data,
});

export const getCMQuestionnaireApi = (data) => client().get('chuck-miller/get-questions', {
  params: data,
});

export const saveCMResponseApi = (data) => client().post('chuck-miller/submit-response', data);

export const getRandomQuestionApi = (data) => client().get('getrandomai-question', {
  params: data,
});

export const submitRandomQuestionApi = (data) => client().post('submit-randomquestionres', data);

export const getAiQuestionApi = (studyId) => client().get(`/aiQuestions?sid=${studyId}`);

export const getRouterV4AIQuestionApi = (data) => client().post('/getRouterV4AIQuestion', data);
export const getRouterV4AINextQuestionApi = (data) => client().post('/getRouterV4AINextQuestion', data);

export const getAiQuestionReviewApi = (data) => client().post('submit-randomquestionres', data, {
  headers: {
    'Content-Type': 'application/json',
  },
});
export const getCheckSecurityPassedApi = async (data) => {
  const result = await client().post('check-calibar8-modal', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return result;
};
